import { Trans, useTranslation } from "react-i18next";
import { getScreeningGradingComparison } from "../../queries/gradeComparisonQueries";
import { showRequestErrorToast } from "../../services/ErrorService";
import { Loading } from "../loading/Loading";
import { GradeComparison as GradeComparisonCharts } from "@idwal/idwal-react-components";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { APIGrade } from "@idwal/idwal-react-components/dist/types/APIGrade";

type Props = {
    imo: string | undefined;
    vesselGrade: APIGrade | undefined;

};

export const ScreeningGradeComparison = (props: Props) => {
    const { imo, vesselGrade } = props;

    const { t } = useTranslation("locale");
    const { user } = useAuthenticator((context) => [
        context.authStatus,
        context.user
    ]);

    const { data, isError, error, isLoading } = getScreeningGradingComparison(
        imo ?? "",
        user
    );

    if (isLoading || data === undefined || vesselGrade === undefined) {
        return <Loading />;
    }

    if (isError) {
        console.error(error);
        showRequestErrorToast("Grading");
        return <div></div>;
    }

    if (!data?.grades?.length) {
        return (
            <div className={"grid"}>
                <div className={"lg:col-8 col-10"}>
                    <p>{t("grade_comparison.unavailableExplanation1")}</p>
                    <br />
                    <p>
                        <Trans
                            i18nKey="grade_comparison.unavailableExplanation2"
                            t={t}
                        >
                            If you would like further information on how this
                            vessel compares to others in the market, please
                            <a
                                className={"portal-link"}
                                href="https://www.idwalmarine.com/contact-us"
                                target="_blank"
                            >
                                contact us
                            </a>
                            .
                        </Trans>
                    </p>
                </div>
            </div>
        );
    }

    return (
        <GradeComparisonCharts
            data={data.grades}
            type={data.type}
            ageRange={data.age_range}
            vesselAge={Number(data.age)}
            vesselGrade={vesselGrade}
        />
    );
};
